import React from 'react'
import { Logo } from '../components/Logo'
import { MenuNightOption } from './MenuNightOption'

export const MenuUnificadoNightOnline = () => {
  return (
    <div className="App">
      <Logo></Logo>
      <MenuNightOption></MenuNightOption>
    </div>
  )
}
